import React, { useState } from 'react';
import { CgCloseR } from 'react-icons/cg'
import { MdOutlineKeyboardArrowUp, MdKeyboardArrowDown, MdDelete } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux';

import { removeToCartList } from '../../../redux/slice/productslice';

const RightSiderbar = ({ right, setRight }) => {
    const [quantity, setQuantity] = useState(1)
    const cartList = useSelector((state) => state.cart.cartList)
    const dispatch = useDispatch()

    return (
        <div className="my-16">
            <div className="h-screen flex flex-col justify-between bg-white shadow-xl  mt-16 pt-5">
                <div className="px-2 sm:px-2 flex justify-between">
                    <p className="text-md font-medium text-gray-900 ">Delivery charge <span className='font-bold'>FREE!</span> from Order tk.999 </p>

                    <CgCloseR onClick={() => setRight(!right)} className='text-black text-2xl font-semibold z-50' />
                </div>

                {/* Replace with your content */}
                <div className="px-4 sm:px-2 h-2/3 overflow-y-scroll">
                    {
                        cartList?.map((item) => <div key={item._id} className="flex justify-between space-y-2 space-x-1 items-center last:border-0 border-b border-gray-400 py-2 overflow-y-scroll">
                            <div className="w-14"><img className='w-full ' src={item.imgUrl} alt="" /></div>
                            <div className="flex flex-col gap-x-2 gap-y-1 pl-2">
                                <h3 className='text-black text-md  font-normal'>{item.title}</h3>
                                <p className='text-sm'>tk {item.price} / 50 gm</p>
                            </div>
                            <div className="flex flex-col gap-1 justify-center items-center">
                                <MdOutlineKeyboardArrowUp onClick={() => setQuantity(quantity + 1)} />
                                <p>{item.qty}</p>
                                <MdKeyboardArrowDown onClick={() => quantity && setQuantity(quantity - 1)} />
                            </div>
                            <div className="text-md font-semibold">{item.price * item.qty}</div>
                            <div className="">
                                <MdDelete onClick={() => dispatch(removeToCartList(item._id))} className='text-2xl cursor-pointer' />
                            </div>
                        </div>
                        )
                    }
                </div>

                {/* /End replace */}

                <div className="flex md:mb-16 mb-36 ">
                    <button className='w-full bg-gradient-to-t hover:from-red-800 hover:to-red-400 from-red-600 to-red-300 py-2 text-white  font-semibold tracking-wider outline-0 border-0'>Checkout tk 15</button>
                </div>
            </div>
        </div>
    );
};

export default RightSiderbar;